import { SxProps, Theme } from '@mui/material';

export const GeneralErrorTitleStyles: SxProps<Theme> = {
  '& svg': {
    '& path': {
      fill: (theme: Theme) => theme.colors.red,
    },
    alignSelf: 'center',
    fontSize: '28px',
    mx: 1,
  },
  display: 'flex',
  justifyContent: 'center',
};
